






























































































































    import {Component, Vue, Watch} from 'vue-property-decorator';
    import MazeGrid, {CellContent} from './MazeGrid.vue';
    import Cat from '../classes/Cat';
    import GridCell from '../classes/GridCell';
    import LoadingModal from '@/components/LoadingModal.vue';

    const throttle = (fn: any, delay: number) => {
        let lastCall = 0;
        return (...args: any) => {
            const now = (new Date()).getTime();
            if (now - lastCall < delay) {
                return;
            }
            lastCall = now;
            return fn(...args);
        };
    };

    @Component({components: {LoadingModal, MazeGrid}})
    export default class MazeManager extends Vue {
        private CellContent = CellContent;

        private elementToSelect: CellContent[] = [
            CellContent.Wall,
            CellContent.Cat,
            CellContent.Mouse,
            CellContent.Milk,
            CellContent.Nothing,
        ];
        private elementSelectedIndex: number = 4;

        private gridSize: number = 10;
        private grid: GridCell[] = [];
        private cat: Cat | null = null;
        private gameLoopInterval: any = null;
        private isCalculatingPath: boolean = false;
        private progress: number = 0;
        private showRulesModal: boolean = false;

        private get elementSelected(): CellContent {
            return this.elementToSelect[this.elementSelectedIndex];
        }

        private created(): void {
            this.populateGridWithEmptyCells();

            window.addEventListener('cat-analyzing-path', throttle((payload: any) => {
                this.progress = payload.detail.progress;
            }, 1000));

            window.addEventListener('cat-ready', (_) => {
                this.isCalculatingPath = false;
                this.progress = 100;
                if (this.gameLoopInterval) {
                    this.clearLoopInterval();
                }
                this.gameLoopInterval = setInterval(() => {
                    this.gameLoop();
                }, 350);
            });

            window.addEventListener('cat-finished', (_) => this.endGameLoop());
        }

        private removeAll(contentToDelete: CellContent): void {
            this.grid.forEach((cell: GridCell) => {
                if (cell.content === contentToDelete) {
                    cell.content = CellContent.Nothing;
                }
            });
        }

        @Watch('gridSize')
        private populateGridWithEmptyCells(): void {
            this.grid = 'x'.repeat(this.gridSize ** 2).split('')
                .map((_: any, position: number) => new GridCell(position));
            GridCell.gridSize = this.gridSize;
        }

        private clearLoopInterval() {
            clearInterval(this.gameLoopInterval);
            this.gameLoopInterval = null;
        }

        private createRandomMaze(): void {
            do 
		{
	    this.grid = this.grid.map((_: GridCell, position: number) => {

                return Math.random() < 0.3
                    ? new GridCell(position, CellContent.Wall)
                    : Math.random() < 0.05
                        ? new GridCell(position, CellContent.Milk)
                        : new GridCell(position);
            });

            const catPos: number = Math.floor(Math.random() * this.gridSize);
            let mousePos: number = 0;
            do {
                mousePos = Math.floor(Math.random() * this.gridSize);
            } while (mousePos === catPos);

            this.grid[catPos].content = CellContent.Cat;
            this.grid[mousePos].content = CellContent.Mouse;
} while(this.grid.filter((cell: GridCell) => cell.content === CellContent.Milk).length > 4);
        }

        private onPlayStopClicked(): void {
            this.stopSpinningAnimations();

            if (this.isGameRunning) {
                this.clearLoopInterval();
            } else {
                if (this.catCell === undefined) {
                    return;
                }
                this.restartCat();
            }
        }

        private restartCat(): void {
            if (!this.catCell) {
                return;
            }
            this.progress = 0;
            this.isCalculatingPath = true;
            this.cat = new Cat(this.catCell, this.grid);
            this.cat.start();
        }

        private onCellClicked(cell: GridCell): void {
            this.stopSpinningAnimations();

            if (this.elementSelected === CellContent.Cat) {
                this.removeAll(CellContent.Cat);
            }

            if (this.elementSelected === CellContent.Mouse) {
                this.removeAll(CellContent.Mouse);
            }

            // Do not let user erase cat or mouse
            if (this.isGameRunning &&
                (cell.content === CellContent.Cat || cell.content === CellContent.Mouse)) {
                return;
            }

            cell.content = this.elementSelected;

            if (this.isGameRunning) {
                this.restartCat();
            }
        }

        private endGameLoop(): void {
            if (!this.isGameRunning) {
                return;
            }

            this.clearLoopInterval();

            if (this.catCell === undefined) {
                return;
            }

            const isMouseAlive: boolean = this.mouseCell !== undefined;

            // @ts-ignore
            isMouseAlive ? (this.mouseCell.isSpinning = true) : (this.catCell.isSpinning = true);
        }

        private gameLoop(): void {
            if (this.cat === null) {
                return;
            }

            this.cat.move();
        }

        private stopSpinningAnimations(): void {
            this.grid.forEach((cell: GridCell) => cell.isSpinning = false);
        }

        private get catCell(): GridCell | undefined {
            return this.grid.find((cell: GridCell) => cell.content === CellContent.Cat);
        }

        private get mouseCell(): GridCell | undefined {
            return this.grid.find((cell: GridCell) => cell.content === CellContent.Mouse);
        }

        private get canStartGame(): boolean {
            return (!!this.mouseCell && !!this.catCell);
        }

        private get isGameRunning(): boolean {
            return !!this.gameLoopInterval;
        }
    }
